
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

const Conclusion: React.FC = () => {
  return (
    <>
      <h2 className="text-2xl font-bold mb-4 mt-8 text-itmgmt-dark-blue">Conclusion: Aligning IT Support with Your Business Journey</h2>
      <p className="mb-6 text-gray-700 leading-relaxed">
        The right IT support model isn't static—it should evolve as your business grows. By understanding your current needs, anticipating future requirements, and recognizing when it's time to transition, you can ensure technology remains an enabler rather than a limitation.
      </p>
      
      <p className="mb-6 text-gray-700 leading-relaxed">
        Whether you're a startup looking for cost-effective basics or an established business needing enterprise-level support, there's an IT model that aligns with your growth stage and helps position you for the next phase of your journey.
      </p>
      
      <div className="bg-itmgmt-light-gray p-6 rounded-lg mt-8 mb-6">
        <h3 className="text-xl font-semibold mb-3 text-itmgmt-dark-blue">Need Help Finding Your Ideal IT Support Model?</h3>
        <p className="mb-4 text-gray-700 leading-relaxed">
          Our consultants can help you assess your current growth stage, technology needs, and recommend the right support approach for your business. Contact us today for a free consultation.
        </p>
        <Button asChild className="mt-2">
          <Link to="/book">Schedule a Free Assessment</Link>
        </Button>
      </div>

      <div className="bg-itmgmt-light-blue/20 border-l-4 border-itmgmt-medium-blue p-6 rounded-lg my-8">
        <h3 className="text-xl font-semibold mb-3 text-itmgmt-dark-blue">Related Reading</h3>
        <p className="mb-4 text-gray-700 leading-relaxed">
          Deepen your understanding with these related articles:
        </p>
        <ul className="list-disc ml-6 mb-2 text-gray-700 leading-relaxed">
          <li className="mb-2">
            <Link to="/blog/cost-of-it-downtime-prevention" className="text-itmgmt-medium-blue hover:text-itmgmt-bright-blue underline">
              The True Cost of IT Downtime (And How to Prevent It)
            </Link>
          </li>
          <li className="mb-2">
            <Link to="/blog/cybersecurity-best-practices-small-business" className="text-itmgmt-medium-blue hover:text-itmgmt-bright-blue underline">
              5 Cybersecurity Best Practices Every Small Business Should Implement
            </Link>
          </li>
          <li className="mb-2">
            <Link to="/blog/cloud-migration-guide-small-businesses" className="text-itmgmt-medium-blue hover:text-itmgmt-bright-blue underline">
              Cloud Migration Strategy: A Step-by-Step Guide for Small Businesses
            </Link>
          </li>
        </ul>
      </div>
    </>
  );
};

export default Conclusion;
